import React from 'react';
import SecurityHero from './SecurityHero/SecurityHero';
import SecurityLogoCarousel from './SecurityLogoCarousel/SecurityLogoCarousel';
import SecurityFeatures from './SecurityFeatures/SecurityFeatures';
import SecurityCta from './SecurityCta/SecurityCta';
import SecurityInfoSection from './SecurityInfoSection/SecurityInfoSection';
import SecurityResources from './SecurityResources/SecurityResources';
import './SecurityPage.css';

function SecurityPage() {
  return (
    // This main tag acts as the root for all page-specific content
    <main className="security-page-main-content">
      <SecurityHero />
      <SecurityLogoCarousel />
      <SecurityFeatures />
      <SecurityCta />
      <SecurityInfoSection />
      <SecurityResources />
    </main>
  );
}

export default SecurityPage;